var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import SpsButtonBase from "./SpsButtonBase";

var SpsButton = function (_Component) {
  _inherits(SpsButton, _Component);

  function SpsButton() {
    _classCallCheck(this, SpsButton);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  SpsButton.prototype.render = function render() {
    var props = _objectWithoutProperties(this.props, []);

    return React.createElement(SpsButtonBase, _extends({}, props, {
      render: function render(_ref) {
        var _ref$props = _ref.props,
            spinning = _ref$props.spinning,
            icon = _ref$props.icon,
            message = _ref$props.message,
            type = _ref$props.type,
            render = _ref$props.render,
            onClick = _ref$props.onClick,
            rest = _objectWithoutProperties(_ref$props, ["spinning", "icon", "message", "type", "render", "onClick"]),
            buttonIcon = _ref.buttonIcon,
            className = _ref.className;

        return React.createElement(
          "button",
          _extends({}, rest, {
            className: className,
            onClick: onClick,
            type: type
          }),
          spinning ? React.createElement(
            "div",
            { className: "sps-spinner" },
            "Loading..."
          ) : null,
          icon ? buttonIcon() : null,
          message
        );
      }
    }));
  };

  return SpsButton;
}(Component);

export { SpsButton as default };